export default __webpack_public_path__ + "static/media/jahaz.1ec399a1.webp";